import React, { useState, useEffect, useRef } from 'react';
import './AssetDistribution.css';
import starIcon from '../../assets/images/star.svg';
import assetDistributionImage from '../../assets/images/fra1.svg';

const AssetDistribution = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Stop observing after animation triggers
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.3, // Trigger when 30% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before element is fully in view
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="dist-asset-container" ref={sectionRef}>
      <div className="dist-text-content">
         
          <h2>
            <span className={`dist-intuitive-text ${isVisible ? 'animate-slide-left delay-300' : ''}`}>Intuitive Asset </span>{' '}
            <span className={`dist-organisation-text ${isVisible ? 'animate-slide-left delay-500' : ''}`}>Organisation</span>
          </h2>
          <p className={`${isVisible ? 'animate-slide-left delay-700' : ''}`}>
            <span className="dist-first-line">Categorize, filter, and label assets in ways that fit your workflow — making everything easy to locate and manage.</span>
          </p>
        </div>
        
      <div className='dist-asset-right'>
        <div className='dist-social-icons-grid'>
          <img 
            src={assetDistributionImage} 
            alt="Asset Distribution" 
            className={`dist-main-image ${isVisible ? 'animate-slide-right delay-500' : ''}`} 
          />
        </div>
      </div>
    </div>
  );
};

export default AssetDistribution;
